import { SVGProps, Ref, forwardRef } from 'react';

export const SendWebFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m8.022 6.2-4.94 10.02c-1.77 3.59-2.655 5.385-1.677 6.334.98.949 3.03.283 7.129-1.047l.765-.248L12 9.378l2.7 11.88.767.249c4.1 1.33 6.15 1.996 7.129 1.047s.094-2.744-1.676-6.333L15.979 6.2C14.268 2.733 13.414 1 12 1S9.73 2.733 8.022 6.2"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendWebFilledSize24Glyph.displayName = 'SendWebFilledSize24Glyph';
